import zod from "zod";
import { uuid } from "./common";
import { webPageComponentSchema } from "./components";

export const stepTimeSchema = zod.object({
    id: uuid,
    stepCode: zod.string().max(255),
    timeSpent: zod.number(),
    createdAt: zod.string().datetime(),
    updatedAt: zod.string().datetime(),
});

export const activeStepSchema = zod.object({
    order: zod.number(),
    id: zod.string().uuid(),
    name: zod.string(),
    code: zod.string(),
    rule: zod.object({
      id: zod.string().uuid(),
      xml: zod.string().nullish(),
      code: zod.string().nullish(),
    }),
    orderStatus: zod.string(),
    page: zod.object({
      id: zod.string().uuid(),
      name: zod.string(),
      description: zod.string().nullable(),
      components: zod.array(webPageComponentSchema),
    }),
});

export type StepTimeType = zod.infer<typeof stepTimeSchema>;
export type ActiveStepType = zod.infer<typeof activeStepSchema>;
